/** CRA/Jest default — no runtime public path prefix. */
export function runtimePublicBase() {
  return ''
}
